<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4 v-if="!data">
                    {{ $t('v4.REGISTER CREDIT CARD') }}
                </h4>
                <h4 v-else>
                    {{ $t('v4.UNREGISTER CREDIT CARD') }}
                </h4>
            </div>
        </div>
        <b-alert
            show
            variant="primary"
        >
            <div class="alert-body">
                <ul style="list-style:circle;margin-top:20px;">
                    <li>
                        {{ $t('v4["If you register your credit card and activate regular billing, you will be charged regularly without the inconvenience of paying monthly."]') }}
                    </li>
                    <li>
                        {{ $t('v4["Card-related payment information is encrypted and managed by PG company KGAllat Co., Ltd. (KGAllat regular payment)"]') }}
                    </li>
                    <li>
                        {{ COMPANY_TITLE }} {{ $t('v4["only stores an encrypted code instead of your card number."]') }}
                    </li>
                    <li>
                        {{ $t('v4["If you no longer want regular billing after registering your card, you can cancel it here."]') }}
                    </li>
                </ul>
            </div>
        </b-alert>
        <div v-if="!data" style="text-align:center;margin:20px;">
            <div style="margin-bottom:20px;">
                <p>
                    <b>{{ $t('v4["Regular billing is not activated."]') }}</b>
                </p>
                <p v-if="hasWritePermission(project)">
                    <b>{{ $t('v4["To activate, please click the next button to proceed."]') }}</b>
                </p>
            </div>
            <div v-if="hasWritePermission(project)">
                <b-button variant="success" @click="enableRegularBilling">
                    <feather-icon icon="CreditCardIcon"/>
                    {{ $t('v4.Register regular billing') }}
                </b-button>
            </div>
            <form ref="FormEnableRegularBilling" id="FormEnableRegularBilling" method="POST" target="hiddenFrame">
                <input type="hidden" name="allat_encode_type" :value="ALLAT_ENCODE_TYPE">
                <input type="hidden" name="allat_shop_id" :value="ALLAT_SHOP_ID">
                <input type="hidden" name="allat_order_no" :value="allatOrderNo">
                <input type="hidden" name="shop_receive_url" :value="enableReceiveUrl">
                <input type="hidden" name="allat_enc_data">
                <input type="hidden" name="allat_product_nm" :value="ALLAT_PRODUCT_NM">
                <input type="hidden" name="allat_email_addr" :value="email">
                <input type="hidden" name="allat_fix_type" :value="ALLAT_FIX_TYPE">
                <input type="hidden" name="allat_test_yn" :value="ALLAT_TEST_YN">
            </form>
        </div>
        <div v-else style="text-align:center;margin:20px;">
            <div style="margin-bottom:20px;">
                <p>
                    <b>{{ $t('v4["Regular billing is activated."]') }}</b>
                </p>
                <p>
                    <b>{{ $t('v4["To cancel, please click the next button"]') }}</b>
                </p>
            </div>
            <div>
                <b-button variant="warning" @click="disableRegularBilling">
                    <feather-icon icon="CreditCardIcon"/>
                    {{ $t('v4.Cancel regular billing') }}
                </b-button>
            </div>
            <form ref="formDisableRegularBilling" id="formDisableRegularBilling" method="POST" target="hiddenFrame">
                <input type="hidden" name="allat_shop_id" :value="ALLAT_SHOP_ID">
                <input type="hidden" name="allat_fix_key" :value="data">
                <input type="hidden" name="shop_receive_url" :value="disableReceiveUrl">
                <input type="hidden" name="allat_enc_data">
                <input type="hidden" name="allat_opt_pin" :value="ALLAT_OPT_PIN">
                <input type="hidden" name="allat_opt_mod" :value="ALLAT_OPT_MOD">
                <input type="hidden" name="allat_fix_type" :value="ALLAT_FIX_TYPE">
                <input type="hidden" name="allat_test_yn" :value="ALLAT_TEST_YN">
            </form>
        </div>
        <div style="margin-bottom:40px;margin-top:20px;" v-if="loading" class="loader-dots"></div>
        <iframe style="left:0px; top:0px; width:0px; height:0px; position:absolute; z-index:1000; display:block; background-color:white;" id="hiddenFrame" name="hiddenFrame" frameborder="0"></iframe>
    </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent'
export default {
    props: {
        data: {
            type: String
        },
        project: {
            type: Object,
            default: function () {
                return {
                    permissions: [],
                    usageAccountId: ''
                }
            }
        },
        user: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data () {
        return {
            loading: false,
            usageAccountId: '',
            COMPANY_TITLE: process.env.VUE_APP_CARDPAY_COMPANY_TITLE,
            SERVER: process.env.VUE_APP_COMMON_URL,
            NAMESPACE: process.env.VUE_APP_NAMESPACE,
            SERVICE_GROUP: process.env.VUE_APP_SERVICE,
            ALLAT_SHOP_ID: process.env.VUE_APP_CARDPAY_REGULAR_SHOP_ID,
            PATH: '/kg/regular-billing',
            ALLAT_ENCODE_TYPE: 'U',
            ALLAT_PRODUCT_NM: 'Amazon Web Services',
            ALLAT_FIX_TYPE: 'FIX',
            ALLAT_TEST_YN: 'N',
            ALLAT_OPT_PIN: 'NOVIEW',
            ALLAT_OPT_MOD: 'WEB'
        }
    },
    computed: {
        email () {
            return this.user.email
        },
        allatOrderNo () {
            return `rb${this.project.usageAccountId}`
        },
        enableReceiveUrl () {
            return `${this.SERVER}${this.PATH}/${this.NAMESPACE}/${this.SERVICE_GROUP}/${this.ALLAT_SHOP_ID}/${this.project.usageAccountId}`
        },
        disableReceiveUrl () {
            return `${this.SERVER}${this.PATH}/cancel/${this.NAMESPACE}/${this.SERVICE_GROUP}/${this.ALLAT_SHOP_ID}/${this.project.usageAccountId}`
        }
    },
    created () {
        window.receiveMessage = this.receiveMessage
    },
    mounted () {
        this.$_allatPayPlus()
    },
    destroyed () {
        window.receiveMessage = undefined
    },
    methods: {
        hasWritePermission (project) {
            return project.permissions && project.permissions.indexOf('WRITE') > -1
        },
        enableRegularBilling () {
            this.loading = true
            window.Allat_Plus_Fix(this.$refs['FormEnableRegularBilling'], '0', '0')
        },
        disableRegularBilling () {
            this.loading = true
            window.Allat_Plus_Fix_Cancel(this.$refs['formDisableRegularBilling'], '0', '0')
        },
        receiveMessage ({ replyCd, replyMsg, message }) {
            this.loading = false
            if (replyCd === '0000') {
                this.$emit('get:allatkey')
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: `${message}`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `${replyMsg}`
                    }
                })
            } else {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: `${replyCd}`,
                        icon: 'CoffeeIcon',
                        variant: 'warning',
                        text: `${replyMsg}`
                    }
                })
            }
        }
    },
    watch: {
        project () {
            this.loading = false
        }
    }
}
</script>

<style>

</style>
